export const ADD_PRODUCTS = 'cart/ADD_PRODUCTS';
export const REMOVE_PRODUCTS = 'cart/REMOVE_PRODUCTS';
export const UPDATE_PRODUCTS = 'cart/UPDATE_PRODUCTS';
